import type { User } from "@supabase/supabase-js";
import { supabase } from "@/integrations/supabase/client";
import {
  buildOAuthProfilePatch,
  resolveOAuthProfileBasicsFromUser,
} from "@/lib/profileAvatar";

interface ProfileOAuthRow {
  first_name?: string | null;
  last_name?: string | null;
  avatar_url?: string | null;
}

/**
 * Backfill empty profile display fields from the authenticated OAuth user.
 * Uses getUser()-fresh identity_data and user_metadata (e.g. Google picture).
 */
export async function syncOAuthProfileFromAuthUser(
  user: User,
  current?: ProfileOAuthRow | null,
): Promise<boolean> {
  const oauth = resolveOAuthProfileBasicsFromUser(user);
  if (!oauth) return false;

  let profileRow = current;
  if (!profileRow) {
    const { data } = await supabase
      .from("profiles")
      .select("first_name, last_name, avatar_url")
      .eq("id", user.id)
      .maybeSingle();
    profileRow = data;
  }

  const patch = buildOAuthProfilePatch(
    {
      firstName: profileRow?.first_name,
      lastName: profileRow?.last_name,
      avatarUrl: profileRow?.avatar_url,
    },
    oauth,
  );

  if (Object.keys(patch).length === 0) return false;

  const { error } = await supabase.from("profiles").update(patch).eq("id", user.id);
  if (error) {
    console.warn("[oauthProfileSync] profile update failed:", error.message);
    return false;
  }

  return true;
}
